<template>
  <div class="usermenu">
    <div class="usermenu-top">
      <!-- 未登录 -->
      <div class="islogin">
        <el-avatar
          class="avatar-user"
          v-if="userInfo"
          :size="72"
          :src="userInfo.avatar"
          @error="errorHandler"
        >
          <img
            src="https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png"
          />
        </el-avatar>
        <el-avatar
          class="avatar-user"
          v-else
          :size="72"
          :src="userUrl"
          @error="errorHandler"
        >
          <img
            src="https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png"
          />
        </el-avatar>
        <div class="title">
          <!-- <span v-if="userInfo">Hi,{{userInfo.username}}</span>
          <span v-else>Hi,欢迎来到{{$store.getters.getSiteInfo.name}}~</span> -->
          <span>CTRL + D 保存网站 避免失联</span>
        </div>
        <a v-if="userInfo" href="javascript:void(0);" class="dl">
          <span @click="toMall">进入礼品商城</span>
        </a>
        <div style="display: flex; justify-content: space-around;">
          <a v-if="!userInfo" href="javascript:void(0);" class="dl">
            <span @click="toLogin">登录</span>
          </a>
          <a v-if="!userInfo" href="javascript:void(0);" class="mfzc">
            <span @click="toRegister">免费注册</span>
          </a>
        </div>
      </div>
      <!-- 登录 -->
      <div class="nologin"></div>
    </div>
    <div class="usermenu-bottom">
      <div class="usermenu-bottom-item" @click="onlineService">
        <div class="icon-warp">
          <i class="el-icon-service"></i>
        </div>
        <a href="" target="_blank">在线客服</a>
      </div>
      <div class="usermenu-bottom-item" @click="helpCenter">
        <div class="icon-warp">
          <i class="el-icon-view"></i>
        </div>
        <span>帮助中心</span>
      </div>
      <div class="usermenu-bottom-item" @click="toFriends">
        <div class="icon-warp">
          <i class="el-icon-user"></i>
        </div>
        <span>邀请好友</span>
      </div>
      <div class="usermenu-bottom-item" @click="toDaifa">
        <div class="icon-warp">
          <i class="el-icon-s-promotion"></i>
        </div>
        <span>给我留言</span>
      </div>
    </div>
  </div>
</template>

<script>
// import { seachLog } from 'network/api'
export default {
  data () {
    return {
      userUrl: require('assets/icons/user.png')
    }
  },
  computed: {
    // 获取用户信息
    userInfo () {
      return this.$store.getters.getUserInfo
    }
  },
  created () {
    // seachLog().then(res => {
    //   console.log(res)
    // })
  },
  methods: {
    errorHandler () {
      return true
    },
    // 进入礼品商城
    toMall () {
      this.$router.push('/orderAdmin/purchase')
    },
    // 去登录
    toLogin () {
      this.$router.push('login')
    },
    // 去注册
    toRegister () {
      this.$router.push('register')
    },
    // 在线客服
    onlineService () {
      window.open(this.$store.getters.getSiteInfo.online_service, '_blank')
    },
    // 帮助中心
    helpCenter () {
      window.open(this.$store.getters.getSiteInfo.online_service, '_blank')
    },
    // 邀请好友
    toFriends () {
      this.$router.push('/account/InviteFriends')
    },
    // 代发指南
    toDaifa () {
      window.open('https://p.qiao.baidu.com/cps/chat?siteId=17416808&userId=36636907&siteToken=edc61d2b2de9c84c479e4de070bd23b2&cp=http%3A%2F%2Fwww.daifaliwu.cn%2Findex&cr=&cw=%E5%AE%98%E7%BD%91', '_blank')
    }
  }
}
</script>

<style scoped src="styles/views/index/indexbanneritem.css">
</style>
